import { EventEmitter, Injectable, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import * as toastr from 'toastr';

@Injectable({
  providedIn: 'root'
})
export class AppToasterService {

  constructor(private sanitizer: DomSanitizer) { 
  }

  info(message: string, title?: string, options?: any) {
    toastr.info(this.sanitizer.sanitize(1,message), this.sanitizer.sanitize(1,title), {positionClass:'toast-top-right'});
  }
  success(message: string, title?: string, options?: any) {
    toastr.success(this.sanitizer.sanitize(1,message), this.sanitizer.sanitize(1,title), {positionClass:'toast-top-right'});
  }
  warn(message: string, title?: string, options?: any) {
    toastr.warning(this.sanitizer.sanitize(1,message), this.sanitizer.sanitize(1,title), {positionClass:'toast-top-right'});
  }
  error(message: string, title?: string, options?: any) {
    if(message!=undefined || title!=undefined){
    toastr.error(this.sanitizer.sanitize(1,message), this.sanitizer.sanitize(1,title), {positionClass:'toast-top-right'});
    }
  }

}
